import { CommonAdapter } from '@core/adapters';
import {
  FetchListByGroupCodePayload,
  FetchListByGroupCodeResponse,
} from '@core/dto';

export class FetchListByGroupCodeUseCase {
  constructor(private readonly commonAdapter: CommonAdapter) {
    this.commonAdapter = commonAdapter;
  }
  public async execute(
    payload: FetchListByGroupCodePayload
  ): Promise<FetchListByGroupCodeResponse[] | []> {
    return await this.commonAdapter.fetchListByGroupCode(payload);
  }
}
